{
  "fiend": [
    "#ff5a2a",
    "BigPackFireHit",
    0.9
  ],
  "undead": [
    "#8fe0a0",
    "FabDecayHit",
    0.9
  ],
  "celestial": [
    "#ffe08a",
    "FabLightShield",
    1.0
  ],
  "fey": [
    "#c8ffd8",
    "FabLightBuffGlintsL0",
    0.85
  ],
  "beast": [
    "#b8e090",
    "FabResilienceEarthShieldL0",
    0.8
  ],
  "plant": [
    "#8fd060",
    "FabResilienceEarthShieldL0",
    0.85
  ],
  "aberration": [
    "#b070ff",
    "FabShadowHit",
    1.0
  ],
  "construct": [
    "#8fb8ff",
    "FabForceHit",
    0.9
  ],
  "dragon": [
    "#ffb050",
    "FabEmberHit",
    1.0
  ],
  "ooze": [
    "#b0e050",
    "FabGreenCorrosiveHit",
    0.85
  ],
  "monstrosity": [
    "#e8a860",
    "FabAetherHit",
    1.0
  ],
  "humanoid": [
    "#f0e4c0",
    "FabLightBuffL0",
    0.85
  ],
  "giant": [
    "#d0b890",
    "FabResilienceEarthShieldL0",
    1.1
  ],
  "fire": [
    "#ff7a2e",
    "BigPackFireHit",
    1.0
  ],
  "water": [
    "#6fc8ff",
    "FabWaterBuffL0",
    0.9
  ],
  "earth": [
    "#d0a870",
    "FabResilienceEarthShieldL0",
    0.95
  ],
  "air": [
    "#e0f4ff",
    "FabCircularBreathingAirAuraL0",
    0.9
  ],
  "ice": [
    "#bfefff",
    "FabIceHit",
    0.9
  ],
  "storm": [
    "#9fc8ff",
    "FabLightningBugHit",
    0.95
  ],
  "arcane": [
    "#c8b8ff",
    "FabAetherHit",
    0.95
  ]
}
